<template>
  <el-dialog
    :visible.sync="showDialog"
    class="dialog-failreason"
    title="查看原因"
    top="0"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleCloseDialog"
  >
    <div class="failreason-content"
      v-if="identificationList&&identificationList.mid_table_remark_006&&identificationList.mid_table_remark_006.length>2"
      :class="identificationList&&identificationList.mid_table_remark_006&&identificationList.mid_table_remark_006.length>2?'marbtm24':'marbtm40'"
    >{{identificationList.mid_table_remark_006}}</div>
    <div
      v-if="identificationList&&identificationList.mid_table_remark_017&&getPicAfter(identificationList.mid_table_remark_017).length"
      class="failreason-pic" 
    >
      <el-image
        class="preview-image"
        :key="`pic-${j}`"
        v-for="(items,j) in getPicAfter(identificationList.mid_table_remark_017)"
        :src="items"
        :fit="fit"
        :preview-src-list="getPicAfter(identificationList.mid_table_remark_017)"
        lazy
      >
        <div slot="placeholder" class="image-slot">
            加载中<span class="dot">...</span>
        </div>
      </el-image>
    </div>
  </el-dialog>
</template>
<script>
import {numberValidator} from "@/assets/js/util";
import pageCommon from "@/utils/pagecommon";
import taskApi from "@/api/task";
export default {
  name: "FailReason",
  mixins: [],
  props: ['identificationList','userInfo'],
  data() {
    return {
      showDialog: false,
      formData: {
        mid_table_remark_006: "",
      },
      rules: {
        mid_table_remark_006: [
          {required: true, message: "请填写报价", trigger: "blur"},
          {validator: numberValidator, trigger: "blur"},
        ]
      },
      isRequesting: false,
      fit: 'cover'
    };
  },
  mounted() {
    let _this = this;
    console.log(this.identificationList)
  },
  methods: {
    getPicAfter(val){
      console.log(val)
      var picList=[];
      if(val&&val.length>3){
        picList.push(val)
      }
      return picList
    },
    handleCloseDialog: function () {
      let _this = this;
      _this.showDialog = false;
    },
    handleSubmit: function () {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting = true;
      if (this.taskInfo.id_public_middle_table&&this.userInfo.id_public_user_info) {
        if(this.taskInfo.mid_table_remark_016){
          if(((Number(this.taskInfo.mid_table_remark_016))*55)<Number(this.formData.mid_table_remark_006)){
            _this.$message.error("您的报价已经超过指导价的10%,将无法完成本次报价");
            _this.isRequesting = false;
            return
          }
        }
        _this.$refs["modifyForm"].validate((valid) => {
          if (valid) {
            let requestData = {
              isloading: true,
              id_public_user_info: this.userInfo.id_public_user_info,
              mid_table_remark_001: this.userInfo.nick_name,
              mid_table_remark_002: this.userInfo.weichat_img,
              mid_table_remark_003: this.userInfo.user_phone,
              mid_table_remark_004: this.taskInfo.id_public_middle_table,
              mid_table_remark_005: this.taskInfo.mid_table_remark_001,
              mid_table_remark_006: this.formData.mid_table_remark_006,
              mid_table_remark_013: this.taskInfo.mid_table_remark_013,
              mid_table_remark_007: 7001,
            }
            pageCommon.apiRequestCommon(taskApi, "insertOfferData", requestData).then(
              (res) => {
                _this.isRequesting = false;
                location.reload();
              },
              (err) => {
                _this.isRequesting = false;
                if (err.sysUserLoginError) {
                  _this.$message.error("系统异常，请稍后刷新重试！");
                } else {
                  _this.$message.error(err.data.msg);
                }
              }
            );
          } else {
            _this.isRequesting = false;
          }
        });
      } else {
        _this.$message.error("页面异常，请稍后刷新重试！");
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.dialog-failreason {
  /deep/ .el-dialog {
    position: absolute;
    width: 540px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    .el-dialog__header {
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 30px 40px 40px;
      box-sizing: border-box;
      .el-dialog__title {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #222222;
        line-height: 20px;
        text-align: left;
      }
      .el-dialog__headerbtn {
        position: relative;
        width: 16px;
        height: 16px;
        overflow: hidden;
        background: url("../../assets/icon_dialog_delete.png") no-repeat;
        background-size: 100% 100%;
        top: 0;
        right: 0;
        .el-dialog__close {
          &::before {
            content: none;
          }
        }
      }
    }
    .el-dialog__body {
      position: relative;
      width: 100%;
      padding: 0px 40px 0;
      box-sizing: border-box;
      .failreason-content{
        font-size: 16px;
        font-weight: normal;
        color: #222;
        line-height: 24px;
        text-align: left;
        &.marbtm24{
          margin-bottom:24px;
        }
        &.marbtm40{
          margin-bottom:40px;
        }
      }
      .failreason-pic{
        margin-bottom:40px;
        width:200px;
        height:150px;
        .preview-image{
          display:block;
          width:100%;
          height:100%;
        }
      }
    }
    .el-form-item {
      margin-bottom: 30px;
    }
  }
}
</style>
